// Components
import { Error } from '@tracklib/kit'
import DerivativePay from 'components/pay/hoc/derivativepay'
import ErrorBoundary from 'errorboundary'
import LicensePay from 'components/pay/hoc/licensepay'
import SEO from 'components/base/seo'

type PayPageProps = {
  match: {
    params: {
      type: string
      paymentId: string
    }
  }
}

const PayPage = ({ match }: PayPageProps): JSX.Element => {
  const { type, paymentId } = match.params
  let selectedPage = null
  if (type === 'revenue') {
    selectedPage = <DerivativePay paymentId={+paymentId} />
  }
  if (type === 'license') {
    selectedPage = <LicensePay paymentId={+paymentId} />
  }
  if (!selectedPage) {
    return <Error />
  }
  return (
    <>
      <SEO title="Payment" />
      <ErrorBoundary>{selectedPage}</ErrorBoundary>
    </>
  )
}

export default PayPage
